<template>
  <div class="col-12">
    <div class="row" style="max-width: 95%; margin: auto">
      <card
        card-body-classes="table-full-width"
        style="box-shadow: initial"
        no-footer-line
      >
        <div class="col-md-12 breadcumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/principal' }"
              >Home</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{
              $t("app.modules.complaints.title")
            }}</el-breadcrumb-item>
            <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>
          </el-breadcrumb>

          <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
          
        </div>
        <el-divider></el-divider>
        <div
          class="
            col-12
            d-flex
            justify-content-center justify-content-sm-between
            flex-wrap
          "
        >
          <h4 class="card-title text-purple">
            {{ $t("app.modules.complaints.title") }}
          </h4>
        </div>
        <n-button
          @click.native="openItemAdd()"
          class="pull-left secondary"
          style="
            float: right;
            margin-right: 20px;
            border-radius: 0px !important;
          "
          round
        >
          {{ $t("app.modules.complaints.buttons.add") }}
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
        </n-button>
        <div>
          <!--<div class="col-12 d-flex">
            <div class="col-2">
              <template>
                <div class="row">
                  <div class="col-5">
                    <drop-down class="btn-group">
                      <template slot="title">
                        <button type="button" class="btn">
                          {{ $t("app.modules.complaints.headers.status") }}
                        </button>

                        <button
                          type="button"
                          class="btn dropdown-toggle dropdown-toggle-split"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                      </template>
                      <a
                        v-for="item in estadosReclamaciones"
                        :key="item.idEstadoReclamacion"
                        class="dropdown-item"
                        href="#"
                        @click="typeSelected = item.idEstadoReclamacion"
                      >
                        {{ item.estadoReclamacion }}
                      </a>
                    </drop-down>
                  </div>
                </div>
              </template>
            </div>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>-->

          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              prop="idReclamacion"
              :label="this.$t('app.modules.complaints.headers.claim_number')"
              sortable
              min-width="250"
            >
            </el-table-column>
            <el-table-column
              prop="fechaRegistro"
              :label="this.$t('app.modules.complaints.headers.create_date')"
              sortable
              min-width="230"
            >
            </el-table-column>
            <el-table-column
              prop="nombreVendedor"
              :label="this.$t('app.modules.complaints.headers.sales_assigned')"
              sortable
              min-width="250"
            >
            </el-table-column>
            <el-table-column
              prop="estadoReclamacion"
              :label="this.$t('app.modules.complaints.headers.status')"
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              className="is-center"
              :min-width="200"
              fixed="right"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <n-button
                  @click.native="EditItem(props.$index, props.row)"
                  type="primary"
                  class="options-button"
                  size="sm"
                  round
                >
                  {{ $t("app.modules.complaints.buttons.show_details") }}
                </n-button>
                <!--<el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          EditItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.complaints.buttons.show_details") }}
                      </n-button>
                    </div>
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          handleDelete(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.complaints.buttons.send") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>-->
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="
            col-12
            d-flex
            justify-content-center justify-content-sm-between
            flex-wrap
          "
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
      <reclamaciones-detail />
    </div>
  </div>
</template>
<script>
import { Pagination as NPagination } from "src/components";
import Fuse from "fuse.js";

export default {
  components: {
    NPagination,
    ReclamacionesDetail: () => import("./reclamacionesview"),
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      // filter by search term
      result =
        this.searchQuery.length > 0
          ? result.filter((d) => d.fechaRegistro.includes(this.searchQuery))
          : result;

      //Filter by Status
      result =
        this.typeSelected > 0
          ? result.filter(
              (d) => d.reclamacion_idEstadoReclamacion == this.typeSelected
            )
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["fechaRegistro", "razonSocial"],
      tableColumns: [
        {
          prop: "numeroCliente",
          label: this.$t("app.modules.complaints.headers.number_cliente"),
        },
        {
          prop: "razonSocial",
          label: this.$t("app.modules.complaints.headers.bussiness_name"),
        },
        {
          prop: "fechaRegistro",
          label: this.$t("app.modules.complaints.headers.registration_date"),
        },
        {
          prop: "nombre",
          label: this.$t("app.modules.complaints.headers.claimant_name"),
        },
        {
          prop: "reclamacion_idEstadoReclamacion",
          visible: false,
          label: this.$t(""),
        },
        {
          prop: "estadoReclamacion",
          label: this.$t("app.modules.complaints.headers.status"),
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      typeSelected: 0,
      estadosReclamaciones: [
        {
          idEstadoReclamacion: 1,
          estadoReclamacion: "Pending Attention",
        },
        {
          idEstadoReclamacion: 2,
          estadoReclamacion: "Confirmed",
        },
      ],
    };
  },
  methods: {
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });
      var payload = { id: 0, estado: this.typeSelected };
      await this.$http
        .post(route("Reclamaciones/getReclamacionesByCliente"), payload)
        .then(
          async (response) => {
            console.log(response);
            if (response.body.code === 200) {
              this.tableData = response.body.reclamaciones;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
    openItemAdd() {
      this.$router.push({
        name: "Nueva Reclamacion",
      });
    },
    EditItem(index, row) {
      EventBus.$emit("reclamaciones-detail", row);
    },
    handleDelete(index, row) {
      this.$refs[ref].doClose();
      this.$swal
        .fire({
          title: this.$t("app.modules.complaints.messages.message_title"),
          text: this.$t(
            "app.modules.complaints.messages.confirm_notificiation"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("app.modules.complaints.buttons.send"),
          cancelButtonText: this.$t(
            "app.modules.complaints.buttons.cancel_send"
          ),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteRow(row);
            this.$swal.fire({
              title: this.$t("app.modules.complaints.messages.message_title"),
              text: this.$t(
                "app.modules.complaints.messages.send_notification"
              ),
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          }
        });
    },
    async deleteRow(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });
      var payload = { id: row.idReclamacion, estado: this.typeSelected };
      await this.$http
        .post(route("Reclamaciones/postAcuseRecibidoReclamacion"), payload)
        .then(
          async (response) => {
            console.log(response);
            if (response.body.code === 200) {
              this.tableData = response.body.reclamaciones;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["fechaRegistro", "razonSocial"],
      threshold: 0.3,
    });
    this.init();

    EventBus.$on("reload-items", () => {
      this.init();
    });
  },
  created() {
    // console.log(this.$route.query.source);
    var source = this.$route.query.source;
    if (source == "bot") {
      this.init();
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
